import styled from 'styled-components';
import { BodyText, FlexBox, FlexRow, SvgIcon, SvgIconSocial } from '@make-software/cspr-design';

export const ContentWrapperTop = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundTertiary,
    width: '100%',
    flexDirection: ['row'],
    justifyContent: 'center'
  })
);

export const ContentWrapperBottom = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    background: theme.styleguideColors.backgroundQuaternary,
    width: '100%',
    flexDirection: ['row'],
    justifyContent: 'center'
  })
);

export const FooterTopBar = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    maxWidth: 1176,
    width: '100%',
    flexDirection: ['column', 'row'],
    padding: ['48px 28px 60px', '48px 32px 56px', '60px 56px', '60px 0px'],
    '> * + *': {
      marginTop: [60, 0],
      marginLeft: [0, 16, 20, 24]
    }
  })
);

export const FooterBottomBar = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    maxWidth: 1176,
    width: '100%',
    flexDirection: ['column', 'row'],
    padding: ['24px 28px', '24px 32px', '24px 56px', '24px 0px'],
    '> * + *': {
      marginTop: [32, 0],
      marginLeft: [0, 16, 20, 24]
    }
  })
);

export const FooterBarColumn = styled(FlexBox)(({ theme }) =>
  theme.withMedia({
    flexDirection: ['column'],
    width: '100%'
  })
);
